export const titles = {
  section0: 'Please review these FAQs before getting started',
  section1: 'Download the computer screen recorder for Mac & Windows',
  section2: 'Download the mobile & tablet screen recorder for iPhone & Android',
};

export const contents = [
  {
    title: 'What is a user research participant?',
    content:
      '<p>Participants (also known as testers) will give their opinion on websites, prototypes, apps, concepts and '
      + 'more. You’ll walk through certain scenarios like finding an item or commenting on how easy something is to use.</p>',
  },
  {
    title: 'How do I sign up for tests?',
    content:
      '<p>Have the Browse Tests tab open on your computer at all times. It will constantly be updated with new studies. </p>',
  },
  {
    title: 'How do I get paid?',
    content:
      '<p>You’ll receive payment within 8 days of the study via PayPal.'
      + ' Please don’t reach out to our team unless payment for a study takes longer than 10 days. You can track '
      + 'payments in the Completed Tests tab.</p>',
  },
  {
    title: 'Is PayPal the only way that I can receive payment?',
    content:
      '<p>Yes, PayPal is the only supported payment method. We do not support other payment methods.</p>',
  },
  {
    title: 'What are screener questions?',
    content: `
        <p>
          Since we limit number of questions that we ask you at sign up, we may
          ask screener questions to gather more information. This helps researchers determine if you’re a fit for the study.
          <br />
          <br />
          Screener questions are short surveys used to qualify you for a paid study. You will not be compensated for screener surveys.
          <br />
          <br />
          Answer these questions truthfully. If a company reports that you did not answer the screener truthfully,
          you will not be compensated for the study.
        </p>
      `,
  },
  {
    title: 'What types of studies can I participate in? ',
    content: `
        <ol>
          <li>Unmoderated: You’ll record your screen and audio while answering questions, without a researcher present.
          (Length of study: 10 - 20 minutes)</li>
          <li>Moderated live conversation: Speak to a researcher one-on-one at a scheduled time. (Length of study: 30,
            60 or 90 minute session)</li>
          <li>Card sort: Sort cards into groups that make sense to you. A researcher will not be present during this
          study, so you can take it on your own time. (Length of of study: 3-10 minutes)</li>
          <li>Tree sort: Researchers will ask you questions about where you would find content on a website.
          A researcher will not be present during this study, so you can take it on your own time. (Length of of study: 3-10 minutes)</li>
        </ol>
      `,
  },
  {
    title: 'What devices can I test on?',
    content: `
        <div>
          <span>Mac</span>
          <ul>
            <li>Operating system: OS X 10.8 or higher</li>
            <li>Memory: At least 1 GB of total RAM and 600MB of available RAM.</li>
            <li>Available disk space: At least 5 GB of free disk space.</li>
            <li>Browser: Chrome, Firefox, Safari</li>
            <li>Upload speed of at least 5.0 Mbps</li>
            <li>Battery level: More than 20%</li>
          </ul>

          <span>Windows</span>
          <ul>
            <li>Operating system: Windows 7, 8 or 10.</li>
            <li>Memory: At least 1 GB of total RAM and 600MB of available RAM.</li>
            <li>Available disk space: At least 5 GB of free disk space.</li>
            <li>Browser: Chrome, Firefox, Edge</li>
            <li>Upload speed of at least 5.0 Mbps</li>
            <li>Battery level: More than 20%</li>
          </ul>

          <span>iOS</span>
          <ul>
            <li>Operating system: iOS 13 or higher</li>
            <li>Memory: At least 500MB of available space on your device</li>
            <li>Battery level: More than 20%</li>
          </ul>

          <span>Android</span>
          <ul>
            <li>Operating system: Android OS 7.0 or higher</li>
            <li>Memory: At least 500MB of available space on your device</li>
            <li>Battery level: More than 20%</li>
          </ul>
        </div>
      `,
  },
  {
    title: 'Do I need a microphone to participate in studies?',
    content: `
        <p>
          Yes, you will need a microphone to participate. Most new devices have a built in microphone, which will be sufficient.
          <br />
          If you do not have a built in microphone, you can purchase an inexpensive one here:
          <a
            href="http://www.amazon.com/Cyber-Acoustics-AC-201-Headset-microphone/dp/B0002QLQ96/"
            target="_blank"
            rel="noopener noreferrer"
            >
              http://www.amazon.com/Cyber-Acoustics-AC-201-Headset-microphone/dp/B0002QLQ96/
          </a>
        </p>
      `,
  },
  {
    title: 'What makes a 5-star participant?',
    content: `
        <div>
          <p>A 5-star participant is someone who speaks their thoughts aloud at all times while taking the study. They
          do more than simply read the content of the page, they make insightful comments and talk about thinks they
          like / dislike. Offering suggestions for improvement is a common characteristic of 5-star testers.</p>

          <span>Do this:</span>
          <ul>
            <li>Answer every task / question</li>
            <li>Speak loudly & clearly</li>
            <li>Perform the study in a quiet room without distractions</li>
            <li>Take at least 10 minutes to complete the study</li>
            <li>Talk about what you like, dislike or should improve</li>
          </ul>

          <span>NOT this:</span>
          <ul>
            <li>Read the content off the page</li>
            <li>Say everything looks “ok” without suggestions for improvement</li>
            <li>Skip questions</li>
            <li>Pause the test for a long period of time</li>
          </ul>
        </div>
      `,
  },
  {
    title: 'How much will I get paid?',
    content: `
      <div>
        <span>We pay:</span>
        <ul>
          <li>$10 / 10 to 20 minute unmoderated session</li>
          <li>$30 / 30 minute moderated interview</li>
          <li>$60 / 60 minute moderated interview</li>
          <li>$90 / 90 minute moderated interview</li>
          <li>$$2 per card sort</li>
          <li>$2 per tree test</li>
        </ul>
      </div>
    `,
  },
  {
    title: 'What are reasons for not getting paid for my test?',
    content: `
      <div>
        <span>Since we want to provide high quality sessions to our clients, we will refuse payment under the following
        circumstances.</span>

        <ul>
          <li>You did not answer all questions (i.e. you skipped questions)</li>
          <li>You did not speak your thoughts out loud for the majority of the video</li>
          <li>Your audio is crackling & unclear</li>
          <li>You have a lot of background noise</li>
          <li>You received calls or texts during a mobile study</li>
          <li>The video is under 10 minutes or you didn’t go thoroughly into each question</li>
          <li>You rushed through the test</li>
          <li>You skipped ahead in the test</li>
          <li>You didn’t review the prototype or website or app thoroughly</li>
          <li>You misrepresented yourself during the screener survey</li>
        </ul>
      </div>
    `,
  },
  {
    title: 'How much can I earn per month as a participant?',
    content:
      '<p>You will be matched with studies based on your demographic profile. You could receive 10 studies a day, or '
        + 'none for a week - it depends on the number of researchers looking for someone like you!</p>',
  },
  {
    title: 'Do I have to download an app to take studies?',
    content: `
      <p>
        For unmoderated studies, you will have to download a computer app to take computer studies. At this time we
        do not have a Chrome extension.
        <br />
        Similarly, we have a tablet and mobile app for tablet and mobile studies.
        <br />
        For moderated studies, you will have to download Zoom on your computer, tablet or mobile phone to participate.
        Here’s how to download Zoom
        <a
          href="https://zoom.us/download"
          target="_blank"
          rel="noopener noreferrer"
          >
          Video Conferencing, Web Conferencing, Webinars, Screen Sharing
        </a>
      </p>
    `,
  },
  {
    title: 'Does PlaybookUX issue a tax form at the end of the year?',
    content: `
      <p>
        No, we do not issue tax forms for participants. You can look up past payments in PayPal. However, if whatever
        funds you have received represent income, you'll be required to report that information on your income tax return
        <br />
        PlaybookUX does not withhold taxes from payments. Participants are responsible for determining any tax liability.
      </p>
    `,
  },
  {
    title: 'Do I have to speak English to participate in studies?',
    content:
      'Everyone in the PlaybookUX panel should have proficiency in English. However, there may be studies in other '
      + 'languages, which will be indicated while you’re applying to studies on the Browse Tests tab.',
  },
  {
    title: 'How soon will I be able to start getting paid to test?',
    content:
      'It will take up to a week to approve your practice test. Once your practice test is approved, you’ll start '
      + 'receiving test opportunities on the Browse Tests tab. New tests will be available regularly.',
  },
];
